import {createUseStyles} from 'react-jss';
import {Theme} from '../themes/default';

const useStepsStyles = createUseStyles((theme: Theme) => {
    return {
        stepsContainer: {
            marginTop: theme.spacing(3),
            textAlign: 'center',
        },
        stepImage: {
            width: '80%',
            height: '90%',
             [theme.breakpoints.down('sm')]: {
                width: '90%',
            },
        },
        textBeforeFormSection: {
            fontFamily: theme.fonts.apex,
            fontSize: '24px',
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            textAlign: 'center',
            padding: theme.spacing(4),
            [theme.breakpoints.down('sm')]: {
                fontSize: '18px',
                padding: theme.spacing(2),
            },
        },
    };
});

export default useStepsStyles;